import * as types from "../../../EarningsGroup/actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.EARNING_PAGE_DATA:
      return action.payload;
    default:
      return state;
  }
}
